/**
 * Dobra de termo para comparação de NOME: sem acento, minúsculo, borda aparada,
 * espaços internos colapsados. Compartilhada por `airport_aliases.ts` (chave do
 * apelido) e `known_city.ts` (nome de cidade): quem grava e quem consulta têm de
 * dobrar do MESMO jeito, senão uma entrada curada nunca casa.
 *
 * Pure (no IO).
 */
export function foldAlias(term: string): string {
  return term
    .normalize('NFD')
    .replaceAll(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase()
    .replaceAll(/\s+/g, ' ');
}
